import Component from '../../../shared/component';

export default class PopDropfilterForm extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$moreButton = this.$element.parent().find('#modal-link');
    this.$actionsDiv = this.$element.parent().find('#filter-dropdown');

    this.bindEvents();
  }

  bindEvents() {
    this.handleMoreClick = this.handleMoreClick.bind(this);

    this.$moreButton.on('click', this.handleMoreClick);
  }

  hideMoreButton() {
    this.$actionsDiv.show();
  }
}
